// Converted to lazy loading
const loyalPointsIndex = () => import('@/pages/loyaltyPoints/loyalPoints/index.vue')
const loyalPointsForm = () => import('@/pages/loyaltyPoints/loyalPoints/form.vue')
const loyalPointsShow = () => import('@/pages/loyaltyPoints/loyalPoints/show.vue')

const loyalPointsPolicyIndex = () => import('@/pages/loyaltyPoints/loyalPointsPolicy/index.vue')
const CreditsRechargeIndex = () => import('@/pages/loyaltyPoints/creditsRecharge/index.vue')
const CreditsRechargeForm = () => import('@/pages/loyaltyPoints/creditsRecharge/form.vue')
const CreditsRechargeShow = () => import('@/pages/loyaltyPoints/creditsRecharge/show.vue')
const CreditsUsageIndex = () => import('@/pages/loyaltyPoints/creditsUsage/index.vue')
const CreditsUsageForm = () => import('@/pages/loyaltyPoints/creditsUsage/form.vue')
const CreditsUsageShow = () => import('@/pages/loyaltyPoints/creditsUsage/show.vue')

const routes = [
  //loyaltyPoints routes

  {
    path: 'loyalPoints',
    name: 'loyalPoints',
    component: loyalPointsIndex
  },
  {
    path: 'loyalPoints/create',
    name: 'loyalPointsCreate',
    component: loyalPointsForm
  },
  {
    path: 'loyalPoints/create',
    name: 'loyalPointsCreate',
    component: loyalPointsForm
  },
  {
    path: 'loyalPoints/:id',
    name: 'loyalPointsShow',
    component: loyalPointsShow
  },
  {
    path: 'loyalPoints/:id/edit',
    name: 'loyalPointsEdit',
    component: loyalPointsForm
  },

  // ------------------
  {
    path: 'loyalPointsPolicy',
    name: 'loyalPointsPolicy',
    component: loyalPointsPolicyIndex
  },

  //Credits Recharge routes

  {
    path: 'creditsRecharge',
    name: 'creditsRecharge',
    component: CreditsRechargeIndex
  },
  {
    path: 'creditsRecharge/create',
    name: 'creditsRechargeCreate',
    component: CreditsRechargeForm
  },
  {
    path: 'creditsRecharge/:id/edit',
    name: 'creditsRechargeEdit',
    component: CreditsRechargeForm
  },

  {
    path: 'creditsRecharge/:id',
    name: 'creditsRechargeShow',
    component: CreditsRechargeForm
  },
  {
    path: 'creditsRecharge/:id',
    name: 'CreditsRechargeShow',
    component: CreditsRechargeShow
  },
  //Credits Usage routes

  {
    path: 'creditsUsage',
    name: 'creditsUsage',
    component: CreditsUsageIndex
  },
  {
    path: 'creditsUsage/create',
    name: 'creditsUsageCreate',
    component: CreditsUsageForm
  },
  {
    path: 'creditsUsage/:id/edit',
    name: 'creditsUsageEdit',
    component: CreditsUsageForm
  },

  {
    path: 'creditsUsage/:id',
    name: 'creditsUsageShow',
    component: CreditsUsageForm
  },
  {
    path: 'creditsUsage/:id',
    name: 'CreditsUsageShow',
    component: CreditsUsageShow
  }
]

export default routes
